import { Button } from "antd";
import Footer from "./../../components/footer";
import "./index.scss";

const NoPrivilege = () => {
  return (
    <div className="no-privilege">
      <div className="title">
        Sorry, you don't have premission to view this page!
      </div>
      <div className="flex flex-center mt20">
        <Button className="mt20 mr20"  onClick={() => {
         window.history.back();
        }}>返回</Button>

        <Button className="mt20" type="primary" onClick={() => {
          sessionStorage.removeItem('functionPrivilege');
          sessionStorage.removeItem('accessToken');
          window.location.href = '/login';
        }}>去登录</Button>
      </div>

      <Footer />
    </div>
  );
}

export default NoPrivilege;